const INITIAL_STATE = {
  customerId: null,
  customerSiteId: null,
  installBase: null,
  bases: [],
};

const refuelReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === "REFUEL_GET_BASES") {
    return {
      ...state,
      bases: action.bases
    };
  } else if (type === "REFUEL_INSTALL_BASE") {
    return {
      ...state,
      installBase: action.installBase
    };
  } else {
    return {
      ...state
    };
  }
};

export default refuelReducer;
